<template>
  <div class="d-flex">
    <h2>{{ heading }}</h2>
    <div class="ml-auto d-flex align-end">
      <slot name="tools"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    headingOverride: String,
  },
  data() {
    return {
      heading: "Paradise",
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        this.headingOverride
          ? (this.heading = this.headingOverride)
          : (this.heading = to.meta.title)
      },
    },
  },
}
</script>

<style lang="scss" scoped></style>
